import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import {
  PATH_ONBOARDING_PAYEE,
  PATH_ONBOARDING_PAYEE_REQUIREMENT_DETAILS
} from "..";
import { useUserId } from "../../../query/hooks/helpers";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { useQueryVerifications } from "../../../query/onboarding/queries/useQueryVerifications";
import { useQueryRequirementsList } from "../../../query/requirements/queries/useQueryRequirementsList";
import { useModalExit } from "../components/ModalExit";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { RouteOnboardingRequirementDetails } from "../steps/EligibilityRequirements/RouteOnboardingRequirementDetails";
import { OnboardingModule } from "../types";

export const RoutePayeeOnboarding: React.FC = () => {
  const history = useHistory();
  const userId = useUserId();
  const queryFeatureFlags = useFeatureFlags();
  const queryVerifications = useQueryVerifications();
  const queryRequirements = useQueryRequirementsList({
    filter: {
      payeeId: userId,
      payerPayeeEngagementIds: {
        "!=": "null"
      }
    }
  });

  const requirements = queryRequirements.data || [];

  const hasPayoutMethodRequirement = requirements.some(
    requirement => requirement.requirementType === RequirementType.PayoutMethod
  );

  const hasNonGeneralRequirements = requirements.some(
    requirement =>
      requirement.requirementType !== RequirementType.Registration &&
      requirement.requirementType !== RequirementType.TaxVerification &&
      requirement.requirementType !== RequirementType.PayoutMethod
  );

  const modules = useMemo((): OnboardingModule[] => {
    const payeeOnboardingModules: OnboardingModule[] = [];

    payeeOnboardingModules.push({
      type: "create_account",
      options: {
        accountTypes: ["Business", "Individual"],
        verificationLevel: "Tax",
        show1099Message: true,
        allowUSInternationalPerson:
          queryFeatureFlags.data?.internationalUsPerson
      }
    });

    payeeOnboardingModules.push({
      type: "certify_tax_payer_info"
    });

    if (hasPayoutMethodRequirement) {
      payeeOnboardingModules.push({
        type: "payout_method"
      });
    }

    if (hasNonGeneralRequirements) {
      payeeOnboardingModules.push({
        type: "eligibility_requirements"
      });
    }

    if (queryFeatureFlags.data?.taxWithholdingOnboarding) {
      payeeOnboardingModules.push({ type: "tax_withholdings" });
    }

    return payeeOnboardingModules;
  }, [
    hasNonGeneralRequirements,
    hasPayoutMethodRequirement,
    queryFeatureFlags.data?.taxWithholdingOnboarding,
    queryFeatureFlags.data?.internationalUsPerson
  ]);

  const modalExit = useModalExit();

  return (
    <Switch>
      {/*CUSTOM ROUTE FOR REQUIREMENTS*/}
      <Route
        path={PATH_ONBOARDING_PAYEE_REQUIREMENT_DETAILS}
        component={RouteOnboardingRequirementDetails}
      />

      <OnboardingFlow
        onBack={
          queryVerifications.data?.tax &&
          queryVerifications.data?.tax !== "None"
            ? () => {
                modalExit.open({
                  onboardingType: "Payee"
                });
              }
            : undefined
        }
        basePath={PATH_ONBOARDING_PAYEE}
        modules={modules}
        onSuccess={() => {
          history.push("/member/dashboard");
        }}
      />
    </Switch>
  );
};
